module.exports = __webpack_public_path__ + "static/media/grayscale.8d2c6d94.jpg";